<dialog-header
  title="Send Test Notification"
  (onClose)="matDialogRef.close()"
></dialog-header>

<div
  mat-dialog-content
  style="
    border-top: 1px solid lightgray;
    border-bottom: 1px solid lightgray;
    background-color: var(--app-container);
  "
>
  <form [formGroup]="form" style="margin-top: 20px">
    <div class="form-field">
      <single-select
        label="Customer"
        inBrackets="email"
        [formCtrl]="customerFormControl"
        [value]="customerFormControl.value"
        [options]="customers"
        property="name"
        [showIcon]="false"
        [showSearch]="true"
      ></single-select>
    </div>
  </form>

  <div class="form-field-label-subtitle" style="margin-top: 20px">
    <strong>Message Preview:</strong>
  </div>
  <div
    class="form-field-label-title"
    style="
      margin-top: 10px;
      padding: 10px;
      background-color: #f5f5f5;
      border-radius: 4px;
    "
  >
    <strong>From:</strong> {{ data?.from?.name }}<br />
    <strong>Message:</strong> {{ data?.message }}
    <div *ngIf="data?.reward" style="margin-top: 5px">
      <strong>Includes Reward:</strong> Yes
    </div>
  </div>
</div>

<div mat-dialog-actions align="end">
  <app-secondary-button
    title="Cancel"
    [disabled]="sending"
    (tapped)="cancel()"
    style="margin-right: 10px"
  ></app-secondary-button>
  <app-primary-button
    title="Send Test"
    [disabled]="form.invalid || sending"
    (tapped)="sendTest()"
    bgColor="var(--app-timber)"
    color="white"
    [icon]="'send'"
  ></app-primary-button>
</div>

<loader [loading]="loading || sending"></loader>
